import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { searchData } from '../common/search/search-data';

@Component({
	selector: 'app-guidelines',
	templateUrl: './guidelines.component.html',
	styleUrls: ['./guidelines.component.less'],
})
export class GuidelinesComponent {
	public navData = searchData;

	constructor(private router: Router) {}

	public filterItems(arr, section: string): any[] {
		return arr.filter(
			(x) =>
				x.route.indexOf(section + '/') !== -1 && x.name !== 'Overview'
		);
	}

	public redirectTo(uri: any) {
		this.router
			.navigateByUrl('/', { skipLocationChange: true })
			.then(() => this.router.navigate([uri]));
	}
}
